import React from 'react';
import { useAuth } from '../authContext/useAuth';
import NotAuthorized from '../pages/NotAuthorized';
import DefaultLayout from '../layouts/DefaultLayout';

interface LocationManagerGuardProps {
  children: React.ReactNode;
}

/**
 * Guard component that prevents ROLE_LOCATION_MANAGER from accessing certain routes
 * Shows NotAuthorized page if location manager tries to access protected routes
 */
const LocationManagerGuard: React.FC<LocationManagerGuardProps> = ({ children }) => {
  const { user } = useAuth();

  // List of routes restricted for ROLE_LOCATION_MANAGER
  const restrictedRoutes = [
    '/document', // Documents
    '/analytics', // Analytics
    '/my-expenses', // My Expenses
    '/maintenance', // Maintenance
    '/support', // Support
    '/admin', // Admin
    '/directories/routes', // Routes
    '/directories/groups', // Groups
    '/directories/drivers', // My Drivers
  ];

  // Check if user is ROLE_LOCATION_MANAGER and trying to access restricted routes
  if (user?.authorities === 'ROLE_LOCATION_MANAGER') {
    const currentPath = window.location.pathname;
    
    const isRestrictedRoute = restrictedRoutes.some(
      (route) => currentPath === route || currentPath.startsWith(route + '/')
    );

    if (isRestrictedRoute) {
      return (
        <DefaultLayout>
          <NotAuthorized />
        </DefaultLayout>
      );
    }
  }

  return <>{children}</>;
};

export default LocationManagerGuard;
